import IconFont from '../../../components/IconFont';
import styles from './style.module.less';

const CopilotAvatar = () => {
  return <IconFont type="icon-zhinengsuanfa" className={styles.leftAvatar} />;
};

export default CopilotAvatar;
